import React, { useContext, useEffect } from "react";

import Field from "../../atoms/field/Field.jsx";
import { GlobalContext } from "../../globals/globalContext.jsx";
import { put } from "../../util/fetch.js";
import Button from "../button/ButtonController.jsx";
import "./styles.styl";
import { useIntl, FormattedMessage } from "react-intl";

export default function Email(props) {
  const intl = useIntl();
  const { subscription, setSubscription } = useContext(GlobalContext);
  const auto_buy = subscription.auto_buy;

  const [isLoading, setIsLoading] = React.useState(false);
  const [reRender, setRender] = React.useState(false);

  const [emailsErrors, setEmailsErrors] = React.useState({});

  const [userEmail, setUserEmail] = React.useState(subscription.customer.email);
  const [customerBillingEmail, setCustomerBillingEmail] = React.useState(
    subscription.customer.billing_email,
  );

  const { onSuccess } = props;

  function handleSubmit() {
    setEmailsErrors({});
    setIsLoading(true);

    const customerUpdateUrl = `${location.origin}/api/customer/update/${subscription.customer.id}`;
    const body = {
      email: userEmail,
      billing_email: customerBillingEmail,
    };
    put(customerUpdateUrl, { body })
      .then((resp) => {
        const updateCustomerEmails = (prevSubscription, emailUpdates) => ({
          ...prevSubscription,
          customer: {
            ...prevSubscription.customer,
            ...emailUpdates,
          },
        });
        setSubscription((prevSubscription) =>
          updateCustomerEmails(prevSubscription, {
            email: resp.email,
            billing_email: resp.billing_email,
          }),
        );
        setIsLoading(false);

        onSuccess && onSuccess();
      })
      .catch((error) => {
        setEmailsErrors(error.data);
        setIsLoading(false);
      });
  }
  useEffect(() => {
    setRender(!reRender);
  }, []);

  return (
    <>
      <div className="login-correspondence-email">
        <div className="email-row">
          <p className="paragraph">
            {" "}
            <FormattedMessage id="loginEmail" />{" "}
          </p>
          <Field
            label={intl.formatMessage({ id: "loginEmail" })}
            name="email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            required
          />
          {emailsErrors["email"] && (
            <div
              className="error"
              dangerouslySetInnerHTML={{ __html: emailsErrors["email"] }}
            />
          )}
        </div>
        <div className="email-row">
          <p className="paragraph">
            <FormattedMessage id="billingEmailHint" />
          </p>
          <Field
            label={intl.formatMessage({ id: "billingEmail" })}
            name="billing_email"
            value={customerBillingEmail}
            onChange={(e) => setCustomerBillingEmail(e.target.value)}
          />
          {emailsErrors["billing_email"] && (
            <div
              className="error"
              dangerouslySetInnerHTML={{
                __html: emailsErrors["billing_email"],
              }}
            />
          )}
        </div>
      </div>
      <div style={{ marginTop: "2.5rem" }}>
        <Button onClick={handleSubmit}>
          {isLoading
                ? "... " + intl.formatMessage({ id: "saveSettings" }) + " ..."
                : intl.formatMessage({ id: "saveSettings" })}
        </Button>
      </div>
    </>
  );
}
